export default __webpack_public_path__ + "static/media/cpr9.9df77805.jpg";